import { TrackedLinkContext } from "@faire/retailer-visitor-shared/components/TrackedLink";
import { ProductTileClickImpressionProvider } from "@faire/retailer-visitor-shared/hooks/ProductTileImpression/ProductTileClickImpressionProvider";
import { ProductTileViewImpressionProvider } from "@faire/retailer-visitor-shared/hooks/ProductTileImpression/ProductTileViewImpressionProvider";
import { IClickInfo } from "@faire/web-api--source/indigofair/data/IClickInfo";
import { ProductTileContainer } from "@faire/web-api--source/indigofair/data/ProductTileContainer";
import { PropsWithChildren } from "react";

import { ILoggingContext } from "../../types";

interface IProductTileImpressionProviderProps {
  loggingContext: ILoggingContext;
  children: React.ReactNode;
}

export const ProductTileImpressionTrackingWrapper: React.FC<
  PropsWithChildren<IProductTileImpressionProviderProps>
> = ({ children, loggingContext }) => {
  return (
    <ProductTileViewImpressionProvider
      context={loggingContext.impressionProviderProps.context}
      requestId={loggingContext.impressionProviderProps.requestId}
      screenContext={loggingContext.impressionProviderProps.screenContext}
      containerContext={loggingContext.impressionProviderProps.containerContext}
      contextToken={loggingContext.impressionProviderProps.contextToken}
    >
      <ProductTileClickImpressionProvider
        productTileContainer={
          loggingContext.impressionProviderProps
            .productTileContainer as ProductTileContainer
        }
        containerName={loggingContext.impressionProviderProps.containerName}
        context={loggingContext.impressionProviderProps.context}
        requestId={loggingContext.impressionProviderProps.requestId}
        isNewProductsCategory={
          loggingContext.impressionProviderProps.isNewProductsCategory
        }
        screenContext={loggingContext.impressionProviderProps.screenContext}
        containerContext={
          loggingContext.impressionProviderProps.containerContext
        }
        contextToken={loggingContext.impressionProviderProps.contextToken ?? ""}
      >
        <TrackedLinkContext.Provider
          value={{
            containerName:
              loggingContext.impressionProviderProps.trackedLinkContainerName ??
              "",
            type: IClickInfo.Type.PRODUCT,
          }}
        >
          {children}
        </TrackedLinkContext.Provider>
      </ProductTileClickImpressionProvider>
    </ProductTileViewImpressionProvider>
  );
};
